import React from 'react';
import ThemeRow from './ThemeRow';

const ThemesTableRows = ({ category, items, columns }) => (
  items.map((item, index) => (
    <ThemeRow
      key={`themes_table_row_${item.id}`}
      category={category}
      theme={item}
      upward={index > 4}
      columns={columns}
    />
  ))
);

export default ThemesTableRows;
